import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { LanguageComponent } from './language.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    HttpClientModule,
    TranslateModule,
    FlexLayoutModule,
  ],
  declarations: [
    LanguageComponent,
  ],
  exports: [LanguageComponent],
  bootstrap: [LanguageComponent]
})
export class LanguageModule { }